
import React from 'react';
import styles from  './Temp.module.css';
import EmailForm from '../components/EmailForm'; 
import PieChartBuySellStrategies from '../components/PieChartBuySellStrategies'; 

function Temp() { 
    
    const getPieData = () => {
        const data = [
            { name: 'Buy', value: 45 },
            { name: 'Sell', value: 25 },
            { name: 'Neutral', value: 30 }
        ];
     
        return data;
    };

    return (
        <div className={styles.main_page}>
            <header className={styles.main_header}>
                <h1>Test Area</h1>
            </header>            
            <main>
                <section className={styles.content} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>                    
                    <EmailForm/>
                    {/* Pass the actual data, not a function */}
                    <PieChartBuySellStrategies 
                        data={getPieData()} 
                        symbolIcon={'https://s2.coinmarketcap.com/static/img/coins/64x64/1.png'} 
                    />
                </section>                
            </main>                     
        </div>
    );
}

export default Temp;



  






